export const environment = {
  production: false,
  baseApiUrl: 'https://preview.mgbsuite.com/api/v1'
};
